import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  APPEND_STORAGE_IMAGE,
  REMOVE_STORAGE_IMAGE,
} from '../constants/actions';

const initialState = {};

export default handleActions(
  {
    [APPEND_STORAGE_IMAGE]: (state, { payload: [key, value] }) =>
      update(state, { $merge: { [key]: value } }),
    [REMOVE_STORAGE_IMAGE]: (state, { payload: imageId }) =>
      update(state, { $unset: [imageId] }),
  },
  initialState,
);
